import React from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import {
	commaAndFloat2Normalizer,
	floatWithComma2Normalizer,
} from "validators";
import { required } from "validators/validation";

import styles from "./formSections.module.scss";

const AmexVmcdSection = ({ allDisabled, initialTabIndex, loading }) => {
	return (
		<>
			<Row className={`${allDisabled ? styles.disabled : ""}`}>
				<Col lg={3}></Col>
				<Col lg={4} className="pb-3">
					V/MC/D
				</Col>
				<Col lg={4} className="pb-3">
					Amex
				</Col>
			</Row>
			<Row>
				<Col lg={3}>Monthly Volume, $</Col>
				<Col lg={4}>
					<Field
						component={CustomInput}
						type="text"
						smLabel={0}
						smSelect={12}
						validate={[required]}
						disabled={allDisabled}
						normalize={commaAndFloat2Normalizer}
						normalizeOnBlur={floatWithComma2Normalizer}
						solveCaretIssue={commaAndFloat2Normalizer}
						name="visaMcDiscover_AMV"
						tabIndex={initialTabIndex}
						placeholder="0.00"
						blurLoading={loading}
					/>
				</Col>
				<Col lg={4}>
					<Field
						component={CustomInput}
						type="text"
						smLabel={0}
						smSelect={12}
						validate={[required]}
						disabled={allDisabled}
						normalize={commaAndFloat2Normalizer}
						normalizeOnBlur={floatWithComma2Normalizer}
						solveCaretIssue={commaAndFloat2Normalizer}
						name="amex_AMV"
						tabIndex={initialTabIndex + 1 || undefined}
						placeholder="0.00"
						blurLoading={loading}
					/>
				</Col>
			</Row>
			<Row>
				<Col lg={3}>Avg Ticket, $</Col>
				<Col lg={4}>
					<Field
						component={CustomInput}
						type="text"
						smLabel={0}
						smSelect={12}
						disabled={allDisabled}
						validate={[required]}
						normalize={commaAndFloat2Normalizer}
						normalizeOnBlur={floatWithComma2Normalizer}
						solveCaretIssue={commaAndFloat2Normalizer}
						name="visaMcDiscover_AVT"
						tabIndex={initialTabIndex + 2 || undefined}
						placeholder="0.00"
						blurLoading={loading}
					/>
				</Col>
				<Col lg={4}>
					<Field
						component={CustomInput}
						type="text"
						smLabel={0}
						smSelect={12}
						disabled={allDisabled}
						validate={[required]}
						normalize={commaAndFloat2Normalizer}
						normalizeOnBlur={floatWithComma2Normalizer}
						solveCaretIssue={commaAndFloat2Normalizer}
						name="amex_AVT"
						tabIndex={initialTabIndex + 3 || undefined}
						placeholder="0.00"
						blurLoading={loading}
					/>
				</Col>
			</Row>
			<Row>
				<Col lg={3}>High Ticket, $</Col>
				<Col lg={4}>
					<Field
						component={CustomInput}
						type="text"
						smLabel={0}
						smSelect={12}
						disabled={allDisabled}
						validate={[required]}
						normalize={commaAndFloat2Normalizer}
						normalizeOnBlur={floatWithComma2Normalizer}
						solveCaretIssue={commaAndFloat2Normalizer}
						name="visaMcDiscover_HT"
						tabIndex={initialTabIndex + 4 || undefined}
						placeholder="0.00"
						blurLoading={loading}
					/>
				</Col>
				<Col lg={4}>
					<Field
						component={CustomInput}
						type="text"
						smLabel={0}
						smSelect={12}
						disabled={allDisabled}
						validate={[required]}
						normalize={commaAndFloat2Normalizer}
						normalizeOnBlur={floatWithComma2Normalizer}
						solveCaretIssue={commaAndFloat2Normalizer}
						name="amex_HT"
						tabIndex={initialTabIndex + 5 || undefined}
						placeholder="0.00"
						blurLoading={loading}
					/>
				</Col>
			</Row>
		</>
	);
};

export default AmexVmcdSection;
